// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__18yjV","filesListContainer":"PosDisputesFiles_filesListContainer__2C0x9","filesButton":"PosDisputesFiles_filesButton__3Jt9k"};